
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avaliacao",
      function () {
        return require("private-next-pages/avaliacao/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avaliacao"])
      });
    }
  